import IconButton from '@material-ui/core/IconButton'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import DeleteIcon from '@material-ui/icons/Delete'
import PropTypes from 'prop-types'
import React from 'react'
import { toastr } from 'react-redux-toastr'
import OrganizationEditDialog from './OrganizationEditDialog'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    },
    active: {
        color: '#4caf50'
    },
    notActive: {
        color: '#f44336'
    }
})

class OrganizationsTable extends React.Component {
    state = {
        openId: null
    }

    handleUpdate = organization => {
        this.props.onUpdate(organization)
    }

    handleOpenDialog = openId => {
        this.setState({ openId })
    }

    handleCloseDialog = () => {
        this.setState({ openId: null })
    }

    handleDelete = remoteId => () => {
        const toastrConfirmOptions = {
            onOk: () => this.props.onDelete(remoteId)
        }
        toastr.confirm('Вы уверены, что хотите удалить организацию?', toastrConfirmOptions)
    }

    render() {
        const { classes, organizations = [] } = this.props
        const { openId } = this.state
        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID организации EasyMS</TableCell>
                            <TableCell>ID организации Expedia.com</TableCell>
                            <TableCell>Имя организации Expedia.com</TableCell>
                            <TableCell>Валюта</TableCell>
                            <TableCell>Активна?</TableCell>
                            <TableCell padding="checkbox" />
                            <TableCell padding="checkbox" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {organizations.map(item => (
                            <TableRow hover key={item.remoteId}>
                                <TableCell>{item.ourId}</TableCell>
                                <TableCell>{item.remoteId}</TableCell>
                                <TableCell>{item.remoteName}</TableCell>
                                <TableCell>{item.currency}</TableCell>
                                <TableCell>
                                    {item.active ? (
                                        <strong className={classes.active}>АКТИВНА</strong>
                                    ) : (
                                        <strong className={classes.notActive}>НЕ АКТИВНА</strong>
                                    )}
                                </TableCell>
                                <TableCell padding="none">
                                    <OrganizationEditDialog
                                        item={item}
                                        open={openId === item.remoteId}
                                        onOpen={this.handleOpenDialog}
                                        onClose={this.handleCloseDialog}
                                        onUpdate={this.handleUpdate}
                                    />
                                </TableCell>

                                <TableCell padding="none">
                                    <IconButton aria-label="Delete" onClick={this.handleDelete(item.remoteId)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        )
    }
}

OrganizationsTable.propTypes = {
    classes: PropTypes.object.isRequired,
    organizations: PropTypes.array.isRequired,
    onDelete: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired
}

export default withStyles(styles)(OrganizationsTable)



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/ExpediaTab/MappingTabs/OrganizationTab/OrganizationTable/OrganizationsTable.js